import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, Row, Col } from 'antd';
import { MySegmented, MyText } from "../../components";
import { SearchContainer, SearchIcon, SearchInput, SearchButton, StyledSegmented } from './style';
import { SearchOutlined, HeartOutlined, HeartFilled } from '@ant-design/icons';
import {useTranslation} from "react-i18next";
import { COOKIE_KEY, fetchContentByCategoryAction, fetchSetLikeAction } from '../../utils';
import { Cookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';

const isMobile = window.innerWidth < 768;
const cookies = new Cookies()

export const Firework = ({ id }: { id: number }) => {
  const {t} = useTranslation("common")
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);

  const [searchParams, setSearchParams] = useSearchParams();
  const [content, setContent] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [likedArticles, setLikedArticles] = useState<{ [key: number]: boolean }>({});
  const [likeCounts, setLikeCounts] = useState<{ [key: number]: number }>({});
  const dispatch = useDispatch();
  const contentByCategory = useSelector((state: any) => state.materials?.contentByCategory ?? { data: null, loading: false });

  // useEffect(() => {
  //   const fetchContent = async () => {
  //     if (id) {
  //       try {
  //         const fetchedContent = await fetchContentByCategory(id);
  //         setContent(fetchedContent.ideas);
  //       } catch (error) {
  //         console.error('Error fetching content:', error);
  //       }
  //     }
  //   };

  //   fetchContent();
  // }, [id]);
  useEffect(() => {
    if (id) dispatch(fetchContentByCategoryAction({ categoryId: id }));
  }, [id]);

  useEffect(() => {
    if (!contentByCategory.success || !contentByCategory.data) return;
    setContent(contentByCategory.data.ideas);
  }, [contentByCategory.success, contentByCategory.data]);

  useEffect(() => {
      if (!Array.isArray(content)) return;
      const initialLikes: { [key: number]: boolean } = {};
      const initialLikeCounts: { [key: number]: number } = {};
  
      content.forEach((item: any) => {
        initialLikes[item.id] = item.is_liked_by_user;
        initialLikeCounts[item.id] = item.like_count;
      });
  
      setLikedArticles(initialLikes);
      setLikeCounts(initialLikeCounts);
    }, [content]);
  
    // const toggleLike = (articleId: number) => {
    //   setLikedArticles((prev) => ({
    //     ...prev,
    //     [articleId]: !prev[articleId],
    //   }));
  
    //   setLikeCounts((prev) => ({
    //     ...prev,
    //     [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
    //   }));
      
    //   fetchSetLike(articleId, 'ideas');
    // };
  const toggleLike = (articleId: number) => {
    setLikedArticles((prev) => ({
      ...prev,
      [articleId]: !prev[articleId],
    }));
    setLikeCounts((prev) => ({
      ...prev,
      [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
    }));
    dispatch(fetchSetLikeAction({ entity_id: articleId, entity_type: 'ideas' }));
  };

  return (
    <Card style={{borderRadius: '20px'}}>
      <SearchContainer>
      {!isMobile && (
        <SearchIcon>
          <SearchOutlined />
        </SearchIcon>
      )}
        <SearchInput
          type="text"
          placeholder={isMobile ? `${t("search")}...` : `${t("searchByKeyword")}...`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <SearchButton isMobile={isMobile}>
        {isMobile ? <SearchOutlined style={{ fontSize: '30px' }} /> : `${t("search")}`}
      </SearchButton>
      </SearchContainer>
      <Row gutter={[32, 48]} style={{ margin: '32px 10px' }}>
        {content && content.map((item: any) => (
          <Col span={24} key={item.id} style={{padding: '0'}}>
          <Row gutter={[0, 16]}>
            <Col span={24}>
              <MyText 
                color='#0A033C' 
                size={isMobile ? 24 : 32} 
                weight={800} 
                style={{ fontFamily: 'Nunito', display: 'block', lineHeight: isMobile ? '24px' : '48px' }}
              >
                {item.question}
              </MyText>
            </Col>
            <Col span={24}>
              <MyText 
                color='#0A033C' 
                size={isMobile ? 16 : 18} 
                style={{ fontFamily: 'Nunito', display: 'block', lineHeight: isMobile ? '22px' : '24px' }}
              >
                <MyText color="#0A033C" size={18} weight={800}>{`${t("answer")}`}: </MyText> &nbsp;
                <span dangerouslySetInnerHTML={{ __html: item?.answer }} />
              </MyText>
            </Col>
            <Col span={24}>
              <Row gutter={8} align="middle">
                <Col>
                {(likedArticles[item.id] ?? item.is_liked_by_user) ? (
                  <HeartFilled
                    style={{
                      fontSize: "16px",
                      color: "rgba(253, 99, 99, 1)",
                      cursor: "pointer",
                    }}
                    onClick={token ? () => toggleLike(item.id) : undefined}
                  />
                ) : (
                  <HeartOutlined
                    style={{
                      fontSize: "16px",
                      color: "rgba(104, 114, 125, 1)",
                      cursor: "pointer",
                      height: '24px'
                    }}
                    onClick={token ? () => toggleLike(item.id) : undefined}
                  />
                )}
                </Col>
                <Col>
                {likeCounts[item.id] > 0 && (
                  <MyText color="rgba(104, 114, 125, 1)" size={16} lineHeight="24px">
                    {likeCounts[item.id]}
                  </MyText>
                )}
                </Col>
                <Col style={{marginTop: isMobile ? '16px' : '0'}}>
                  <MyText color="rgba(104, 114, 125, 1)" size={isMobile ? 18 : 20} lineHeight={isMobile ? "22px" : "32px"} weight={600}>
                    {item.author}
                  </MyText>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        ))}
      </Row>
    </Card>
  );
};
